const ROUTE_TRANSITION_DURATION_MS = 250;
const routeTransitionCls = "_275r9w2yeg";

/* prettier-ignore */
const wrapperCls = "_275w6ycpmi";
const contentCls = "_275c15c2qlm";
const headerCls = "_275h11xriur";
const headingCls = "_275h13lg1xb";

export { ROUTE_TRANSITION_DURATION_MS, contentCls, headerCls, headingCls, routeTransitionCls, wrapperCls };
import "./content.style.linaria.module.css";
//# sourceMappingURL=content.style.js.map
